import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useQuizContext } from "../contexts/QuizContext";

const ProtectedQuizRoute = () => {
  const { canAttemptQuiz, quizStarted } = useQuizContext();

  // Allow access if the quiz is either allowed to start or has already started
  return canAttemptQuiz || quizStarted ? (
    <Outlet />
  ) : (
    <Navigate to="/quiz-settings" />
  );
};

export default ProtectedQuizRoute;
